import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Auth } from "aws-amplify";
import { Glyphicon } from "react-bootstrap";

import "./App.css";
import logo from './logo.svg';
import logoHover from './logoHover.svg';
import config from "./config/aws";
import Routes from "./Routes";

class App extends Component {

  constructor(props) {
    super(props);
    this.handleLogoHover = this.handleLogoHover.bind(this);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      isLogoHovered: false
    };
  }

  waitForInit() {
    return new Promise((res, rej) => {
      const hasGapiLoaded = () => {
        if (window.gapi != null) {
          res();
        } else {
          setTimeout(hasGapiLoaded, 300);
        }
      };
      hasGapiLoaded();
    });
  }

  loadGoogleSDK() {
    window.gapi.load('auth2', function(){
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      window.auth2 = window.gapi.auth2.init({
        client_id: config.social.GOOGLE,
        cookiepolicy: 'single_host_origin',
        // Request scopes in addition to 'profile' and 'email'
        //scope: 'additional_scope'
      });
    });
  }

  async componentDidMount() {
    await this.waitForInit();
    this.loadGoogleSDK();

    try {
      await Auth.currentAuthenticatedUser();
      this.userHasAuthenticated(true);
    }
    catch(e) {
      if (e !== 'No current user') {
        console.log(e);
      }
    }
    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = async event => {
    await Auth.signOut();
    this.userHasAuthenticated(false);
    this.props.history.push("/login");
  }

  logo() {
    if (!this.state.isLogoHovered) {
      return <img src={logo} style={{width:35, marginTop: -8, marginRight: 12}} />
    } else {
      return <img src={logoHover} style={{width:35, marginTop: -8, marginRight: 12}} />
    }
  }

  handleLogoHover() {
    this.setState({
      isLogoHovered: !this.state.isLogoHovered
    });
  }


  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
    };
    return (
      !this.state.isAuthenticating &&
      <div className="App container">
        <Navbar fluid collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/">
                <div className="title" onMouseEnter={ this.handleLogoHover} onMouseLeave={ this.handleLogoHover }>
                  { this.logo() }
                  <span style={{color: '#4A4A4A'}}>habit</span>
                  <span style={{color: '#D4D4D4'}}>streaks</span>
                </div>
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              {this.state.isAuthenticated
                ?
                <Fragment>
                  <LinkContainer to="/">
                    <NavItem>dashboard</NavItem>
                  </LinkContainer>
                    <LinkContainer to="/profile">
                      <NavItem>profile</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/login">
                    <NavItem onClick={this.handleLogout}>logout</NavItem>
                    </LinkContainer>
                  </Fragment>
                : <Fragment>
                    <LinkContainer to="/login">
                      <NavItem>login</NavItem>
                    </LinkContainer>
                  </Fragment>
              }
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Routes childProps={childProps} />
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js